import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import DropdownWithCheckboxMenu from "../../../../../../../components/DropdownWithCheckboxMenu";
import { PUBLIC_URL } from "../../../../../../App/configs/Constants";
import { useDispatch, useSelector } from "react-redux";
import { dashboardDeskBookingFilterAction } from "../../../../../actions/DashboardActions";
import {
  PROPERTY,
  ROOM_BOOKING_ALL_STATUS,
  ROOM_BOOKING_CANCELLED_STATUS,
  ROOM_BOOKING_COMPLETED_STATUS,
  ROOM_BOOKING_CONFIRMED_STATUS,
  ROOM_BOOKING_DECLINED_STATUS,
  ROOM_BOOKING_NOT_REFUNDED_STATUS,
  ROOM_BOOKING_PENDING_REFUNDED_STATUS,
  ROOM_BOOKING_PENDING_STATUS,
  ROOM_BOOKING_REFUND_FILTER,
  ROOM_BOOKING_REFUNDED_STATUS,
} from "../../../../../configs/Constants";
import {
  dashboardDeskBookingFilterSelector,
  dashboardFilterDateRangeSelector,
  dashboardPropertyChooseSelector,
} from "../../../../../selectors/DashboardSelectors";
import { LocalizationContext } from "../../../../../../../locales/Translation";
import { createDeskBookingStatusFilterService } from "../../../../../services/DashboardServices";
import { usePermissionCheck } from "../../../../../../../utils/custom-hooks";
import { UI_ACCESS_TRANSACTION_BY_FILTER_PER } from "../../../../../../../utils/PermissionConstant";

const FilterDeskBooking = () => {
  const { translations } = useContext(LocalizationContext);

  const dispatch = useDispatch();
  const dashboardDeskBookingFilter = useSelector(
    dashboardDeskBookingFilterSelector
  );
  const dashboardFilterDateRange = useSelector(
    dashboardFilterDateRangeSelector
  );
  const dashboardPropertyChoose = useSelector(dashboardPropertyChooseSelector);

  const propertyContext = usePermissionCheck(
    UI_ACCESS_TRANSACTION_BY_FILTER_PER
  );

  const [deskBookingStatus, setDeskBookingStatus] = useState<
    { id: string; name: string }[]
  >([]);

  if (propertyContext) {
    useEffect(() => {
      (async () => {
        try {
          if (
            dashboardFilterDateRange === null ||
            dashboardPropertyChoose === null
          ) {
            return;
          }
          await createDeskBookingStatusFilterService({
            translations,
            setStatus: setDeskBookingStatus,
            type: PROPERTY,
            propertyContext,
          });
        } catch (e) {
          console.log("e", e);
        }
      })();
    }, [
      dashboardDeskBookingFilter?.keyword,
      dashboardFilterDateRange,
      dashboardPropertyChoose,
    ]);
  } else {
    useEffect(() => {
      (async () => {
        try {
          if (dashboardFilterDateRange === null) {
            return;
          }
          await createDeskBookingStatusFilterService({
            translations,
            setStatus: setDeskBookingStatus,
            type: PROPERTY,
            propertyContext,
          });
        } catch (e) {
          console.log("e", e);
        }
      })();
    }, [dashboardDeskBookingFilter?.keyword, dashboardFilterDateRange]);
  }

  const _onChangeFilter = (e: SyntheticEvent, data: any) => {
    if (data.value === ROOM_BOOKING_ALL_STATUS) {
      if (data.checked) {
        dispatch(
          dashboardDeskBookingFilterAction({
            key: "status",
            value: [
              ROOM_BOOKING_ALL_STATUS,
              ROOM_BOOKING_CONFIRMED_STATUS,
              ROOM_BOOKING_PENDING_STATUS,
              ROOM_BOOKING_DECLINED_STATUS,
              ROOM_BOOKING_CANCELLED_STATUS,
              ROOM_BOOKING_COMPLETED_STATUS,
            ],
          })
        );
        dispatch(
          dashboardDeskBookingFilterAction({
            key: "refund_status",
            value: [
              ROOM_BOOKING_PENDING_REFUNDED_STATUS,
              ROOM_BOOKING_REFUNDED_STATUS,
              ROOM_BOOKING_NOT_REFUNDED_STATUS,
            ],
          })
        );
      } else {
        dispatch(
          dashboardDeskBookingFilterAction({
            key: "status",
            value: [],
          })
        );
        dispatch(
          dashboardDeskBookingFilterAction({
            key: "refund_status",
            value: [],
          })
        );
      }
      return;
    }

    if (data.checked) {
      if (ROOM_BOOKING_REFUND_FILTER.includes(data.value)) {
        const newValue = [
          ...dashboardDeskBookingFilter.refund_status,
          data.value,
        ];
        dispatch(
          dashboardDeskBookingFilterAction({
            key: "refund_status",
            value: newValue,
          })
        );
      } else {
        const newValue = [...dashboardDeskBookingFilter.status, data.value];
        dispatch(
          dashboardDeskBookingFilterAction({
            key: "status",
            value: newValue,
          })
        );
      }
      return;
    }

    if (ROOM_BOOKING_REFUND_FILTER.includes(data.value)) {
      const newValue = dashboardDeskBookingFilter.refund_status.filter(
        (status: string) =>
          status !== data.value && status !== ROOM_BOOKING_ALL_STATUS
      );
      dispatch(
        dashboardDeskBookingFilterAction({
          key: "refund_status",
          value: newValue,
        })
      );
    } else {
      const newValue = dashboardDeskBookingFilter.status.filter(
        (status: string) =>
          status !== data.value && status !== ROOM_BOOKING_ALL_STATUS
      );
      dispatch(
        dashboardDeskBookingFilterAction({
          key: "status",
          value: newValue,
        })
      );
    }
  };

  return (
    <div className={"dropdown-filter"}>
      <DropdownWithCheckboxMenu
        onChange={_onChangeFilter}
        listCheckBox={deskBookingStatus.map((filter: any) => {
          if (ROOM_BOOKING_REFUND_FILTER.includes(filter.id)) {
            if (dashboardDeskBookingFilter.refund_status.includes(filter.id)) {
              filter.checked = true;
            } else {
              filter.checked = false;
            }

            return filter;
          }

          if (dashboardDeskBookingFilter.status.includes(filter.id)) {
            filter.checked = true;
          } else {
            filter.checked = false;
          }

          return filter;
        })}
        label={translations.filters}
        icon={
          <img
            alt={"Deskimo"}
            src={PUBLIC_URL + "/assets/icons/icon-filter.svg"}
          />
        }
      />
    </div>
  );
};

export default FilterDeskBooking;
